export default __webpack_public_path__ + "static/media/icons-enroll.c482ff30.svg";